<template lang='pug'>
  .sharing__buttons
    slot(name="before")
    .sharing__intro(v-if='intro' :class="addClasses.intro")
      slot(name="intro" :intro="intro")
        span(v-html='intro')
    .buttons__buttons
      button.sharing__button.buttons__button(v-for='social in socials_arr'
        :class="[social,addClasses.button]"
        @click='share(social)')
        slot(name="button" :social="social")
          span(:class="'icon-'+social")
    slot(name="after")
</template>

<script>
  //get meta tags
  import {mobile_mixin, post} from "@/base/utils";
  //import axios from 'axios';

  export function getMeta(name) {
    const meta = document.querySelector('meta[property="og:'+name+'"]');
    return meta && meta.getAttribute('content')
  }

  export default {
    name: "share",
    data: function () {return {}},
    props: {
      //base
      intro: {type: String, default: ''},
      socials: {type: Array, default: function () {return ['vk','fb','ok','tw']}},
      socials_mob: {type: Array, default: function () {return ['tg','wa','vk','fb','ok','tw']}},
      use_mob: {type: Boolean, default: false},
      //goals
      share_text: {type: String, default: 'share_'},
      share_all: {type: String, default: ''},
      //meta
      share_url: {type: [Object,String], default: null},
      share_title: {type: [Object,String], default: null},
      share_descr: {type: [Object,String], default: null},
      share_image: {type: [Object,String], default: null},
      descr2title: {type: Boolean, default: false},
      custom_tag: {type: Function, default: function (social,tag) {return null}},
      //newShare
      newShare: {type: [Boolean,Function], default: false},
      newShareParams: null,
      //special classes
      addClasses: {type: Object, default: () => ({})},
    },
    mounted: function () {},
    mixins:[mobile_mixin],
    computed: {
      socials_arr() {return this.use_mob && this.inMobile ? this.socials_mob : this.socials;}
    },
    methods: {
      share: function (social) {
        let url = encodeURIComponent(this.custom_tag(social,'url') || this.share_url || getMeta('url') || location.href);
        let title = encodeURIComponent(this.custom_tag(social,'title') || this.share_title || (!this.share_url ? getMeta('title'): '') || '');
        let descr = encodeURIComponent(this.custom_tag(social,'descr') || this.share_descr || (!this.share_url ? getMeta('description'): '') || '');
        if (this.descr2title && ((social === 'vk' || social === 'tw') && this.share_descr != null)) title = descr;
        console.log(decodeURIComponent(title),decodeURIComponent(descr));
        let image = encodeURIComponent(this.share_image || (!this.share_url ? getMeta('image'): '') || '');
        //console.log('data:',url,image,title);

        function getLink() {
          switch (social) {
            case 'vk':return 'https://vk.com/share.php?url='+url+'&title='+title+'&image='+image;
            case 'fb':return 'https://www.facebook.com/share.php?u='+url;
            case 'tw':return 'https://twitter.com/intent/tweet?url='+url+'&text='+title;
            case 'ok':return 'https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&service=odnoklassniki&st.shareUrl='+url;
            case 'tb':return 'https://www.tumblr.com/widgets/share/tool?posttype=link&canonicalUrl='+url+'&title='+title;
            case 'tg':return 'https://t.me/share/url?url='+url+'&text='+title;
            case 'wa':return 'whatsapp://send?text='+url;
            //'https://wa.me/?text='+url
          }
        }
        window.open(getLink(), 'Поделиться', 'width=500,height=500,resizable=yes,scrollbars=yes,status=yes');
        console.log('sharing -->', social);
        //console.log(url,title,descr,image);

        if (this.share_text !== '') this.goal(this.share_text+social);
        if (this.share_all !== '') this.goal(this.share_all);

        if (this.newShare === true) post('new_share/',{social_share: social, ...this.newShareParams});
        else if (this.newShare) this.newShare(social, this.newShareParams);
      }
    }
  }
</script>

<style lang='stylus'>
  @import "./social-font.css"
  @import "../base/mixins.styl"

  .sharing__buttons, .social__buttons
    flex_centered()
    font-size: 3.5rem;
    .buttons__buttons
      display: flex;
    .sharing__button, .social__button
      flex_centered()
      margin: 0 .5rem;
      cursor: pointer
</style>